import model from 'api'
import * as types from 'mutation-types'
import { getSessionStorage, setSessionStorage } from 'utils/storage'

const state = {
  list: [],
  total: 0,
  params: getSessionStorage('terminal_list_params') || {
    pageNo: 1,
    pageSize: 15
  },
  current: {},

  commandDialog: false,
  configDialog: false,
  strategyDialog: false,

  loadingList: false
}

const getters = {}

const mutations = {
  [types.TERMINAL_SET_LIST] (state, { list, total }) {
    state.list = list
    state.total = total
  },
  [types.TERMINAL_SET_LOADING_LIST] (state, loading) {
    state.loadingList = loading
  },
  [types.TERMINAL_TOGGLE_COMMON_DIALOG] (state, { current, visible }) {
    state.current = current
    state.commandDialog = visible
  },
  [types.TERMINAL_TOGGLE_CONFIG_DIALOG] (state, { current, visible }) {
    state.current = current
    state.configDialog = visible
  },
  [types.TERMINAL_TOGGLE_STRATEGY_DIALOG] (state, { current, visible }) {
    state.current = current
    state.strategyDialog = visible
  },
  [types.TERMINAL_SET_PARAMS] (state, data) {
    state.params = Object.assign(state.params, data)
  }
}

const actions = {
  async getList ({ commit, state }) {
    try {
      commit(types.TERMINAL_SET_LOADING_LIST, true)
      const { list, total } = await model.Terminal.getList(state.params)
      commit(types.TERMINAL_SET_LIST, { list, total })
    } catch (e) {
      commit(types.TERMINAL_SET_LIST, { list: [], total: 0 })
    } finally {
      setSessionStorage('terminal_list_params', state.params)
      commit(types.TERMINAL_SET_LOADING_LIST, false)
    }
  },
  async setParams ({ commit, dispatch }, params) {
    commit(types.TERMINAL_SET_PARAMS, params)
    await dispatch('getList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
